/*
 * Collective agreement tariff rates.
 *
 * Rates change on a fixed date, so each bracket carries the day it takes
 * effect and the active one is resolved against the current date.
 */

import moment, { Moment } from 'moment';

import findLast from 'lodash/findLast';
import sortBy from 'lodash/sortBy';

export type TariffOption = { label: string; value: string; tariff: number };

type TariffBracket = { validFrom: string; options: Array<TariffOption> };

// Sorted ascending on load so resolveTariffOptions can rely on the order —
// entries may be added in any position, but validFrom must stay ISO
// (YYYY-MM-DD) for the lexicographic sort to match chronological order.
const tariffs: Array<TariffBracket> = sortBy(
  [
    {
      validFrom: '2026-01-01',
      options: [
        { label: 'EG 1', value: 'eg_1', tariff: 14.96 },
        { label: 'EG 2a', value: 'eg_2a', tariff: 15.29 },
      ],
    },
    {
      validFrom: '2026-09-01',
      options: [
        { label: 'EG 1', value: 'eg_1', tariff: 15.33 },
        { label: 'EG 2a', value: 'eg_2a', tariff: 15.67 },
      ],
    },
  ],
  'validFrom',
);

export function resolveTariffOptions(at: Moment | string = moment()) {
  const day = moment(at);
  const bracket =
    findLast(tariffs, ({ validFrom }) => day.isSameOrAfter(validFrom, 'day')) ??
    tariffs[0];

  return bracket.options;
}

export const tariffOptions = resolveTariffOptions();

// Lowest rate in the active bracket — the form prefills with it, and it is
// the floor minimumSalary falls back to for an unknown tariff code.
export const DEFAULT_SALARY = Math.min(
  ...tariffOptions.map(({ tariff }) => tariff),
);
